import React from 'react';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import Faq from '../../../../shared/components/Faq';
import { getFaqContent } from '../../LogoPackages/lib';
import { MOBILE_CHOOSE_VARIATION } from '../propTypes';
import SamplesSlider from '../SamplesSlider';
import VariationsCard from '../VariationsCard';
import VariationSellerCard from '../VariationSellerCard';
import classes from './index.module.scss';

const FAQ_CONTENT = getFaqContent();

const MobileChooseVariation = ({
    projectIsSaved,
    isProjectOwner,
    seller,
    isMobile,
    onSavedProjectChange = noop,
    onMainSampleRendered = noop,
}) => (
    <div className={classes.mobileChooseVariation}>
        <SamplesSlider
            projectIsSaved={projectIsSaved}
            isMobile={isMobile}
            onSavedProjectChange={onSavedProjectChange}
            onMainSampleRendered={onMainSampleRendered}
        />
        <VariationsCard className={classes.floatingVariationsCard} isProjectOwner={isProjectOwner} />

        {seller && <VariationSellerCard className={classes.mobileSellerCard} seller={seller} />}
        <Faq
            className={classes.makersFaq}
            title={<I18n k="logo_maker_perseus.choose_variation.faq.title" />}
            faqContent={FAQ_CONTENT}
        />
    </div>
);

MobileChooseVariation.propTypes = MOBILE_CHOOSE_VARIATION;

export default MobileChooseVariation;
